import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { ReactElement, useState } from "react";

import ChipGroup from "../../../components/ChipsGroup/ChipsGroup";
import Container from "../../../components/Container/Container";
import { Fund } from "../../../utils/types/investor.type";
import {
    useFundsListEffect,
    useUpdateFundsListEffect,
} from "./InvestorFunds.hooks";
import { ChipsContent } from "./InvestorFunds.style";

const InvestorFundsReadOnly: React.FC<{
    investorFundList: Fund[]
}> = ({
    investorFundList
}: { investorFundList: Fund[] }): ReactElement => {    
    return (
      <Container id="investor_funds_container" role="main">
        <Grid container>
          <Grid item md={5} xs={8} >
            <Typography variant="formTitle2">Funds</Typography>
            <Box
              sx={{
                marginTop: "10px",
              }}
            >
              <ChipsContent>
                <ChipGroup
                  ChipTitleList={investorFundList}
                  color={"green"}
                />
              </ChipsContent>
            </Box>
          </Grid>
        </Grid>
      </Container>
    );
  };
  
  export default InvestorFundsReadOnly;